import { configureStore } from "@reduxjs/toolkit";
import usersSlice from "@lhd/features/users/usersSlice";
import companySlice from "@lhd/features/Company/companySlice";
import searchAreaSlice from "@lhd/components/SearchAreaBox/searchAreaSlice";
import sidebarSlice from "@lhd/components/CommonLayout/sidebarSlice";
import maintenanceBannerSlice from "@lhd/components/CommonLayout/maintenanceBannerSlice";
import displaySizeSlice from "@lhd/components/DisplaySizeSelector/displaySizeSlice";
import globalReducer from "./slices";
import meetingSlice from "@lhd/features/ProjectManager/store/meetingSlice";
import projectStatusFilterSlice from "@lhd/features/ProjectManager/components/ProjectStatusFilter/projectStatusFilterSlice";

const store = configureStore({
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // /me payload is large; default 32ms threshold is noisy in local dev.
      serializableCheck: { warnAfter: 256 },
      immutableCheck: { warnAfter: 256 },
    }),
  reducer: {
    [globalReducer.name]: globalReducer.reducer,
    [usersSlice.name]: usersSlice.reducer,
    [companySlice.name]: companySlice.reducer,
    [searchAreaSlice.name]: searchAreaSlice.reducer,
    [sidebarSlice.name]: sidebarSlice.reducer,
    [maintenanceBannerSlice.name]: maintenanceBannerSlice.reducer,
    [displaySizeSlice.name]: displaySizeSlice.reducer,
    [meetingSlice.name]: meetingSlice.reducer,
    [projectStatusFilterSlice.name]: projectStatusFilterSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
